module.exports = __webpack_public_path__ + "img/develop2.02c96541.jpg";